<template>
    <div class="d-flex align-items-center" :title="displayFile.name">
        <div class="mr-2">
            <component
                :is="fileIconComponent('displayFile')"
                :size="iconSize"
                :class="returnFileIcon('displayFile').color"/>
        </div>
        <div class="text-break mr-4">{{ truncate(displayFile.name, 26) }}</div>
        <div>{{ returnFileSize(displayFile.size) }}</div>
        <div v-if="fileTooLarge" class="text-danger ml-2">{{ $t('File size is too big') }}</div>
        <span v-if="!uploading" class="font-weight-bold ml-2">
            <CheckIcon
                v-if="statusType === 'success'"
                size="22"
                class="text-success mb-1"
                :style="{'stroke': '#a5c365', 'stroke-width': '1px'}"/>
            <span v-if="statusType === 'danger'" :class="color">{{ $t('Error while uploading!') }}</span>
        </span>
        <div v-else class="spinner-border spinner-border-sm text-primary ml-2" role="status">
            <span class="sr-only">{{ $t('Loading...') }}</span>
        </div>
    </div>
</template>

<script>
import { truncate } from '@/filters';
import EventBus from '@/utils/eventBus';
import FileMixin from '@common/mixins/File.mixin';
import CheckIcon from '@/common/components/svg-icons/CheckIcon.vue';

export default {
    name: 'DisplayFile',
    mixins: [FileMixin],
    props: {
        displayFile: {
            types:[File, Object] //TODO can it be helped?
        },
        fileTooLarge: {
            type: Boolean,
            default: false
        },
        upload: {
            type: Boolean,
            default: true
        },
        index: null,
        iconSize: {
            type: Number,
            default: 27
        }
    },
    data() {
        return {
            color: '',
            statusType: '',
            uploading: true
        };
    },
    methods: {
        truncate, // TDOD: Vue3 remove
        reUpload() {
            this.$emit('reupload', this.displayFile);
        },
        handleUploadStatus(data) {
            this.status = data.status;
            this.color = data.color;
            this.statusType = data.statusType;
            this.uploading = data.uploading;
        }
    },
    components: {
        CheckIcon
    },
    mounted() {
        if(!this.upload) {
            this.uploading = false;
        }
        EventBus.on(`${this.displayFile.name}-${this.index}`, this.handleUploadStatus);
    },
    destroyed() {
        EventBus.off(`${this.displayFile.name}-${this.index}`, this.handleUploadStatus);
    }
};
</script>
